import classNames from 'classnames';
import { sanitize } from 'dompurify';
import { ComponentRef, useEffect, useRef } from 'react';

interface Props {
  className?: string;
  html?: string;
}

/**
 * A div component to renders an HTML as a string value.
 * The string is sanitized to prevent XSS attacks.
 */
export const DivHtmlText = ({ className, html }: Props) => {
  const ref = useRef<ComponentRef<'div'>>(null);
  useEffect(() => {
    if (!ref.current) return;
    //sanitized text to prevent XSS attacks.
    const safeHtml = sanitize(html ?? '');
    ref.current.innerHTML = safeHtml;
  }, [html]);

  return <div ref={ref} className={classNames('div-html-text', className)} />;
};
